import {
  authActions,
  AuthActions,
  AuthScope,
  AuthState,
  ReducerChain,
  UserData,
  withScope,
} from "@gamedev-web/gamedev-sdk-core";

const initialState: UserData = {
  isFetched: false,
  userInfo: undefined,
};

export const updateUser = (
  state: AuthState,
  action: ReturnType<typeof authActions.updateUser>
): AuthState => ({
  ...state,
  isFetched: true,
  userInfo: action.userInfo,
});

const authReducerWithoutScope = new ReducerChain<AuthState>(initialState)
  .on(AuthActions.UPDATE_USER, updateUser)
  .build();

export const authReducer = withScope(AuthScope, authReducerWithoutScope);
